import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogGuide from "@/pages/blog/vigorbuy-spreadsheet-complete-guide/page";
import SafetyGuide from "@/pages/blog/vigorbuy-spreadsheet-safety-guide/page";
import CategoryComparison from "@/pages/blog/vigorbuy-spreadsheet-category-comparison/page";
import BeginnerTutorial from "@/pages/blog/vigorbuy-spreadsheet-beginner-tutorial/page";
import HowToUse from "@/pages/blog/vigorbuy-spreadsheet-how-to-use/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-complete-guide",
    element: <BlogGuide />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-safety-guide",
    element: <SafetyGuide />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-category-comparison",
    element: <CategoryComparison />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-beginner-tutorial",
    element: <BeginnerTutorial />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-how-to-use",
    element: <HowToUse />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;